import { render, staticRenderFns } from "./discontinuedparts.vue?vue&type=template&id=03542932&lang=pug"
import script from "./discontinuedparts.vue?vue&type=script&lang=js"
export * from "./discontinuedparts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports